import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";


class SearchTextFilter extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.getText = this.getText.bind(this);
    this.state = { defaultValue: "" };
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearFilters !== prevProps.clearFilters) {
      this.setState({ defaultValue: "" });
    }
  }
  UNSAFE_componentWillMount() {
    if(this.props.defaultValue) {
      this.setState({ defaultValue: this.props.defaultValue });
    } else if (this.props.isValidGrid) {
      this.setState({ defaultValue: this.getText(this.props.clientSideFilters) });
    }
  }

  getText(filter) {
    let columnToFilter = this.props.column.key;
    let value = filter[columnToFilter] ? filter[columnToFilter].filterTerm : "";
    return value;
  }

  handleChange(e) {
    let value = e.target.value;
    this.props.onChange({ filterTerm: value, column: this.props.column, rawValue: value });
    this.setState({ defaultValue: value });
  }

  render() {
    let inputKey = "header-filter-" + this.props.column.key;
    let columnStyle = {
      float: "left",
      marginRight: 5,
      maxWidth: "100%"
    };

    return (
      <div>
        <div style={columnStyle}>
          <input key={inputKey} type="text" value={this.state.defaultValue} placeholder="Filter" className="form-control input-sm" onChange={this.handleChange} />
        </div>
      </div>
    );
  }
}

SearchTextFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  column: PropTypes.object,
  clientSideFilters: PropTypes.object.isRequired,
  defaultValue: PropTypes.string, //this will override the client side filters because the client side filters are coming directly from state and that is bad
  isValidGrid: PropTypes.bool.isRequired,
  clearFilters: PropTypes.number
};

const mapStateToProps = (state) => {
  return {
    clearFilters: state.filters.clearFilters
 };
};

export default connect(mapStateToProps)(SearchTextFilter);
